import React from "react";
import { Formik, FormikProps } from "formik";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "Stores/Management/types";
import { Person } from "@src/Interfaces/Entity/Person";
import { Position } from "@src/Interfaces/Entity/Position";
import { Handover } from "@src/Interfaces/Entity/Handover";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import MessageWithReplacements from "@src/Components/Common/MessageWithReplacements/MessageWithReplacements";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { SSTFormTitleTypography, ButtonsGrid, STNote } from "./styles";
import moment from 'moment'
import _ from "lodash";

interface IProps {
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
  onClose: () => void;
  currentPerson: Person;
  handover: Handover;
}

@inject("values", "management", "auth")
@observer
export default class PendingHandoverForm extends React.Component<IProps> {  
  @observable isLoading: boolean = true;
  handoverTo: Person;
  position: Position;

  async componentDidMount() {
    await Promise.all([
      await this.props.management.getPerson(this.props.handover.handoverTo),
    ]).then(x => {
      this.handoverTo = x[0];
      this.position = _.find(this.props.management.activePositions, x => x.id == this.props.handover.position);
      this.isLoading = false;
    });
  }

  async onSubmit() {
    await this.props.management.withdrawHandover();
    this.props.onClose();
  }

  async onRetrigger() {
    await this.props.management.retriggerHandover();
    this.props.onClose();
  }

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }

    return (
      <Formik
        initialValues={this.props.handover}
        onSubmit={() => this.onSubmit()}
        render={(formikProps: FormikProps<Handover>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            <SSTFormTitleTypography>{Values.getLocalizationValue("handover")}</SSTFormTitleTypography>
            <Grid
              container
              spacing={16}
              justify="flex-start"
              alignItems="center">
              <Grid item>
                <MessageWithReplacements
                  message={"pendingHandoverMessage"}
                  replacements={[
                    { key: "position", replacement: this.position.name, bold: true},
                    { key: "to", replacement: this.handoverTo.fullName, bold: true },
                    { key: "since", replacement: moment.utc(this.props.handover.createdTimeString).local().format("d MMMM YYYY HH:mm:ss") }
                  ]} />
              </Grid>
            </Grid>
            {_.isEmpty(this.props.handover.creatorNote) ? <></> : <Grid
              container
              spacing={16}
              justify="flex-start"
              alignItems="center">
              <Grid item style={{ width: "100%", marginTop: "12px" }}>
                <b>{Values.getLocalizationValue("note")}</b>:<br />
                <STNote>{this.props.handover.creatorNote}</STNote>
              </Grid>
            </Grid>}
            <ButtonsGrid container justify="center">
              <STButtonMargin
                onClick={formikProps.handleSubmit}
                variant="contained"
                color="secondary">
                {Values.getLocalizationValue("withdrawHandover")}
              </STButtonMargin>
              <STButtonMargin
                onClick={() => this.onRetrigger()}
                variant="contained"
                color="primary">
                {Values.getLocalizationValue("retriggerHandover")}
              </STButtonMargin>
              <STButtonMargin
                onClick={this.props.onClose}
                variant="contained">
                {Values.getLocalizationValue("close")}
              </STButtonMargin>
            </ButtonsGrid>
          </STFormWrapper>
        )}
      />
    );
  }
}
